import * as common from './common.json';

export const ja = {
  common,
};
